// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgDefaultCamOff24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 200 201"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M100 200.047C155.228 200.047 200 155.276 200 100.047C200 44.8189 155.228 0.0473633 100 0.0473633C44.7715 0.0473633 0 44.8189 0 100.047C0 155.276 44.7715 200.047 100 200.047ZM53.7051 86.7293C53.7051 90.391 56.6314 93.3628 60.237 93.3628C63.8427 93.3628 66.769 90.391 66.769 86.7293V70.8089C66.769 67.1472 63.8427 64.1754 60.237 64.1754C56.6314 64.1754 53.7051 67.1472 53.7051 70.8089V86.7293ZM68.31 142.623C74.9334 147.214 86.9652 152.547 100.121 152.547C109.487 152.547 119.442 149.84 128.43 142.225C131.2 139.877 131.578 135.698 129.266 132.885C126.954 130.073 122.839 129.688 120.069 132.036C100.748 148.394 76.7754 132.408 75.665 131.651C72.6864 129.595 68.6235 130.378 66.5986 133.403C64.5607 136.427 65.3314 140.554 68.31 142.623ZM138.62 93.3628C135.014 93.3628 132.088 90.391 132.088 86.7293V70.8089C132.088 67.1472 135.014 64.1754 138.62 64.1754C142.225 64.1754 145.152 67.1472 145.152 70.8089V86.7293C145.152 90.391 142.225 93.3628 138.62 93.3628ZM96.5979 113.263C96.5979 112.756 96.6538 112.262 96.7598 111.787V72.1356C96.7598 68.4739 99.6861 65.5021 103.292 65.5021C106.897 65.5021 109.824 68.4739 109.824 72.1356V106.63H114.887C118.493 106.63 121.419 109.602 121.419 113.263C121.419 116.925 118.493 119.897 114.887 119.897H103.13C99.5242 119.897 96.5979 116.925 96.5979 113.263Z"
					fillOpacity={0.32}
				/>
			</Svg>
		);
	}
);
SvgDefaultCamOff24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgDefaultCamOff24;
